import { Chip } from '@mui/material'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import { ICONE } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { FRONTOFFICE_CONDIVISO } from 'configuration/frontoffice'
import ConfigManager from 'components/config/ConfigManager'
import { calcolaStatoPagamentoVerbale, STATO_PAGAMENTO_VERBALE } from 'pages/Frontoffice/utilFrontoffice'

const CFG = FRONTOFFICE_CONDIVISO

export default function BadgeStatoPagamento(props) {
  const { verbale, stato: statoCalcolato, ...rest } = props
  const stato = statoCalcolato || calcolaStatoPagamentoVerbale(verbale)

  const mapStatoToCfg = {
    [STATO_PAGAMENTO_VERBALE.PAGABILE]: { icon: <CreditCardIcon />, color: 'warning', t: CFG.STATO_PAGABILE },
    [STATO_PAGAMENTO_VERBALE.NON_PAGABILE]: { icon: <ICONE.BLOCCATO />, color: 'error', t: CFG.STATO_NON_PAGABILE },
    [STATO_PAGAMENTO_VERBALE.PAGATO]: { icon: <ICONE.CONFERMA />, color: 'success', t: CFG.STATO_PAGATO },
  }
  const cfgStato = mapStatoToCfg[stato] ?? null

  return (
    <>
      {cfgStato &&
        <ConfigManager
          elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_CONDIVISO]}
          render={propsConfig =>
            <Chip
              size='small'
              {...rest}
              {...cfgStato}
              label={propsConfig.txt(cfgStato.t)}
            />
          }
        />
      }
    </>
  )
}